/**
 * Resolves the Stripe publishable key based on the current environment.
 *
 * - Set REACT_APP_ENV=staging in Amplify Console for the staging branch
 * - Set REACT_APP_STRIPE_PUBLISHABLE_KEY_STAGING in Amplify Console for the staging branch
 * - Set REACT_APP_STRIPE_PUBLISHABLE_KEY in Amplify Console for the production branch
 */
const STRIPE_PUBLISHABLE_KEY = (
  process.env.REACT_APP_ENV === 'staging'
    ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_STAGING || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    : process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
)?.trim();

export default STRIPE_PUBLISHABLE_KEY;
